import { render } from "./AcceptPoliciesCheckbox.vue?vue&type=template&id=15746efc"
import script from "./AcceptPoliciesCheckbox.vue?vue&type=script&lang=js"
export * from "./AcceptPoliciesCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/forms/AcceptPoliciesCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15746efc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15746efc', __exports__)) {
    api.reload('15746efc', __exports__)
  }
  
  module.hot.accept("./AcceptPoliciesCheckbox.vue?vue&type=template&id=15746efc", () => {
    api.rerender('15746efc', render)
  })

}


export default __exports__